/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取搜索联想
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  keyword: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.SearchLenovoDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/search-lenovo/${keyword}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
